import consts from '../consts';

export function normalizarValorConflitoFase(valor) {
  if (valor === true || valor === 1 || valor === '1') return true;
  if (valor === false || valor === 0 || valor === '0') return false;
  return Boolean(valor);
}

export function listarCamposConflitoDoAnel(numeroFasesIni, numeroFasesFim) {
  const fields = [];
  const faseIni = parseInt(numeroFasesIni, 10);
  const faseFim = parseInt(numeroFasesFim, 10);

  if (!Number.isFinite(faseIni) || !Number.isFinite(faseFim) || faseFim <= faseIni) {
    return fields;
  }

  const fasesIni = faseIni + 1;
  for (let idxFase = fasesIni; idxFase <= faseFim; idxFase++) {
    for (let idx = fasesIni; idx <= idxFase; idx++) {
      fields.push(`fase${idx - 1}_fase${idxFase}`);
    }
  }

  return fields;
}

/** Copia conflitos do redux-form para o objeto do anel (memória local do form). */
export function syncConflitosFormParaAnel(valores, anelIndex) {
  const anel = valores && valores.aneis && valores.aneis[anelIndex];
  if (!anel) return;

  const fields = listarCamposConflitoDoAnel(anel.numero_fases, anel.numero_fases_fim);
  fields.forEach(fieldName => {
    if (valores[fieldName] !== undefined && valores[fieldName] !== null) {
      anel[fieldName] = normalizarValorConflitoFase(valores[fieldName]);
    }
  });
}

/** Copia conflitos do anel para o redux-form (faixa do anel). */
export function syncConflitosAnelParaForm(aneis, anelIndex, changeFn) {
  const anel = aneis && aneis[anelIndex];
  if (!anel || !changeFn) return;

  const fields = listarCamposConflitoDoAnel(anel.numero_fases, anel.numero_fases_fim);
  fields.forEach(fieldName => {
    if (anel[fieldName] !== undefined && anel[fieldName] !== null) {
      changeFn(fieldName, normalizarValorConflitoFase(anel[fieldName]));
    }
  });
}

/**
 * Antes do PUT: garante que todos os pares fase*_fase* dos anéis ativos
 * estejam no payload enviado ao backend (controlador_fase_conflito).
 */
export function consolidarConflitosAneisNoForm(aneis, changeFn, numFase = consts.NUM_FASE || 16) {
  if (!Array.isArray(aneis) || !changeFn) return;

  aneis.forEach(anel => {
    if (!anel || parseInt(anel.ativo, 10) !== 1) return;

    const faseIni = parseInt(anel.numero_fases, 10);
    const faseFim = parseInt(anel.numero_fases_fim, 10);
    if (!Number.isFinite(faseIni) || !Number.isFinite(faseFim)) return;

    for (let f = faseIni + 1; f <= faseFim; f++) {
      for (let i = faseIni; i < f; i++) {
        const fieldName = `fase${i}_fase${f}`;
        if (anel[fieldName] !== undefined && anel[fieldName] !== null) {
          changeFn(fieldName, normalizarValorConflitoFase(anel[fieldName]));
        }
      }
    }
  });
}
